import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const ProtectedRoute = ({ role, children, loginPath }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated(role)) {
    return <Navigate to={loginPath} replace />;
  }

  return children;
};

export default ProtectedRoute;